export { default } from './BotPromptTriggerSettings';
